import { lazy, Suspense, type ComponentType } from 'react'
import { PageLoader } from '@/components/PageLoader'

export function lazyPage(
  loader: () => Promise<{ default: ComponentType<Record<string, never>> }>
) {
  const Lazy = lazy(loader)
  return function LazyPage() {
    return (
      <Suspense fallback={<PageLoader />}>
        <Lazy />
      </Suspense>
    )
  }
}
